import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { ImageImportComponent } from '../image_import/image_import.component';
import { TagEditorModule } from '../tag-editor/tag-editor.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ImageImportComponent],
  exports: [ImageImportComponent],
  imports: [BrowserModule, BrowserAnimationsModule, TranslateModule, TagEditorModule, FormsModule],
  providers: []
})
export class ImageImportModule {}



// WEBPACK FOOTER //
// ./src/app/modules/image_import/image_import.module.ts